import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP } from './LegalPages';

export function ContactPage() {
  const { t } = useTranslation();

  const channels = [
    { title: t('contact.sales_title'), email: t('contact.sales_email'), body: t('contact.sales_body') },
    { title: t('contact.support_title'), email: t('contact.support_email'), body: t('contact.support_body') },
    { title: t('contact.press_title'), email: t('contact.press_email'), body: t('contact.press_body') },
    { title: t('contact.security_title'), email: t('contact.security_email'), body: t('contact.security_body') },
  ];

  return (
    <LegalShell titleKey="contact.title">
      <LegalLead>{t('contact.lead')}</LegalLead>

      <div className="mt-6 grid gap-px bg-ink-200 border border-ink-200 md:grid-cols-2">
        {channels.map((c) => (
          <div key={c.title} className="bg-white p-5">
            <p className="text-xs uppercase tracking-wide text-accent-700 font-medium">{c.title}</p>
            <p className="mt-2 text-sm font-semibold text-ink-900 font-mono">
              <a href={`mailto:${c.email}`} className="hover:text-accent-700">
                {c.email}
              </a>
            </p>
            <p className="mt-2 text-[13px] text-ink-600 leading-relaxed">{c.body}</p>
          </div>
        ))}
      </div>

      <LegalH2>{t('contact.mail_title')}</LegalH2>
      <LegalP>{t('contact.mail_body')}</LegalP>

      <p className="mt-6 text-[13px] text-ink-600 italic">{t('contact.languages_note')}</p>
    </LegalShell>
  );
}
